var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.11612 15.1161H1.625C1.45924 15.1161 1.30027 15.0503 1.18306 14.9331C1.06585 14.8158 1 14.6569 1 14.4911V11C1 10.9179 1.01617 10.8367 1.04758 10.7608C1.07898 10.685 1.12502 10.6161 1.18306 10.5581L10.5581 1.18306C10.6753 1.06585 10.8342 1 11 1C11.1658 1 11.3247 1.06585 11.4419 1.18306L14.9331 4.67417C15.0503 4.79139 15.1161 4.95036 15.1161 5.11612C15.1161 5.28188 15.0503 5.44085 14.9331 5.55806L5.55806 14.9331C5.50002 14.9911 5.43112 15.0371 5.35529 15.0685C5.27947 15.1 5.19819 15.1161 5.11612 15.1161Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.e65c5aee9f019ed8d17e495ceb7a0519.svg";
export { ForwardRef as ReactComponent };